import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setActiveAssetExcelData, setActiveAssetGridData, setIsGridDataLoading } from 'Store/AssetManagement/ActiveAssetDashboard/ActiveAssetDashboardAction';
import { GET_ACTIVE_ASSET_EXCEL_DATA, GET_ACTIVE_ASSET_GRID_DATA } from 'Store/AssetManagement/ActiveAssetDashboard/ActiveAssetDashboardType';


function* getActiveAssetExcelSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Exporting Excel...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/dashboard/excel`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setActiveAssetExcelData({ response: response, status: "success" }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetExcelData({ response: {}, status: "failed" }))
    }
}

function* getActiveAssetGridSaga(req?: any): any {
    try {
        yield put(setIsGridDataLoading(true));
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/dashboard`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsGridDataLoading(false));
        yield put(setActiveAssetGridData({ response: response, status: "success" }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setIsGridDataLoading(false));
        yield put(setActiveAssetGridData({ response: {}, status: "failed" }))
    }
}

function* watchCreateAssement() {
    yield takeEvery(GET_ACTIVE_ASSET_EXCEL_DATA, getActiveAssetExcelSaga)
    yield takeLatest(GET_ACTIVE_ASSET_GRID_DATA, getActiveAssetGridSaga)
}

export default function* combinedSaga() {
    yield all([
        watchCreateAssement()
    ])
}